import { render, staticRenderFns } from "./ClassHoursLogDrawer.vue?vue&type=template&id=487fd5e4&scoped=true"
import script from "./ClassHoursLogDrawer.vue?vue&type=script&lang=js"
export * from "./ClassHoursLogDrawer.vue?vue&type=script&lang=js"
import style0 from "./ClassHoursLogDrawer.vue?vue&type=style&index=0&id=487fd5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fd5e4",
  null
  
)

export default component.exports